import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

const PhoneWireframe = () => {
    return (
        <>
          <Container>
            <Row>
              <img
                src={"/images/iPhone-12-transparent-12.png"}
              />
            </Row>
          </Container>      
        </>
    );
};

export default PhoneWireframe;
